<template>
  <!-- Services ================================================== -->
  <div class="bs-docs-section pt-1 mx-3" id="services">
    <div class="jumbotron">
      <div class="row">
        <div class="col-lg-12">
          <div class="page-header text-center">
            <h4 id="containers">Services</h4>
            <hr class="w-80" />
          </div>
        </div>
      </div>
      <div class="row">
        <div
          v-for="(service, index) in Finult_Services"
          class="col-sm-12 col-md-6 col-lg-4"
          :key="index"
        >
          <div class="service-box">
            <div class="service-icon lightBlue">
              <span :class="service.service_image_css"></span>
              <div class="front-content">
                <h3>{{ service.service_name }}</h3>
              </div>
            </div>
            <div class="service-content">
              <h3>{{ service.service_name }}</h3>
              <p
                v-for="(item, index) in service.service_description"
                :key="index"
              >
                - {{ item }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import db from "@/firebase/init.js"
import jsonData from "@/components/json/Finult_Services.json";
export default {
  name: "Services",
  data() {
    return {
      Finult_Services: []
    };
  },
  created() {
    console.log(this.$useFirestore);
    if (this.$useFirestore) {
      this.Finult_Services = this.$options.filters.getFireStoreRecords(
        "Finult_Services"
      );
    } else {
      this.Finult_Services = jsonData.Finult_Services;
    }
  }
};
</script>

<style></style>
